<template>
  <div class="copy-link-wrapper d-flex align-items-center">
    <a @click.prevent="copyLink">
      <slot name="icon"></slot>
    </a>
    <transition name="fade">
      <div v-if="copy" class="alert alert-success text-center mb-0 ms-1">
        <p class="mb-0">Lenke kopiert</p>
      </div>
    </transition>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const copy = ref(false)
let timeoutId = null

function copyLink() {
  copy.value = false
  if (timeoutId) clearTimeout(timeoutId)
  // Next tick to ensure transition out if already visible
  setTimeout(() => {
    copy.value = true
    navigator.clipboard.writeText(window.location.href)
    timeoutId = setTimeout(() => {
      copy.value = false
    }, 3000)
  }, 10)
}
</script>

<style scoped>
.link-cursor {
  cursor: pointer;
}
.copy-link-wrapper {
  display: flex;
  align-items: center;
}
.alert {
  min-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style> 